import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  Table,
} from 'semantic-ui-react';

import SnukTableAddButton from './SnukTableAddButton';
import SnukTableBody from './SnukTableBody';
import SnukTableFetchBody from './SnukTableFetchBody';
import SnukTableHeader from './SnukTableHeader';

const SnukTable = (props) => {
  const {
    shape, editable, fetcher, textAlign, withAddButton,
    doubleHeaderRow, doubleRowEditable,
    isEditModalOpen, containerEditElem: ContainerEditElem,
    isDeleteModalOpen, containerDeleteElem: ContainerDeleteElem,
    ...rest
  } = props;
  const BodyToRender = fetcher ? SnukTableFetchBody : SnukTableBody;
  return (
    <Fragment>
      {withAddButton && withAddButton.containerElem
        && <SnukTableAddButton {...withAddButton} />}
      <Table celled striped textAlign={textAlign}>
        <SnukTableHeader
          shape={shape}
          editable={editable}
          doubleHeaderRow={doubleHeaderRow}
          doubleRowEditable={doubleRowEditable}
        />
        <BodyToRender shape={shape} editable={editable} {...rest} />
        {isDeleteModalOpen && <ContainerDeleteElem />}
      </Table>
    </Fragment>
  );
};

SnukTable.propTypes = {
  shape: PropTypes.shape({}).isRequired,
  editable: PropTypes.bool,
  fetcher: PropTypes.bool,
  textAlign: PropTypes.string,
  withAddButton: PropTypes.shape(SnukTableAddButton.propTypes),
  doubleHeaderRow: PropTypes.bool,
  doubleRowEditable: PropTypes.bool,
  isEditModalOpen: PropTypes.bool,
  containerEditElem: PropTypes.func,
  isDeleteModalOpen: PropTypes.bool,
  containerDeleteElem: PropTypes.func,
};

SnukTable.defaultProps = {
  editable: false,
  fetcher: false,
  textAlign: null,
  withAddButton: null,
  doubleHeaderRow: false,
  doubleRowEditable: false,
  isEditModalOpen: false,
  containerEditElem: null,
  isDeleteModalOpen: false,
  containerDeleteElem: null,
};

export default SnukTable;



// WEBPACK FOOTER //
// ./src/components/reusable/SnukTable/SnukTable.js